import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const getStoredNeighborhood = () => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const storedValue = localStorage.getItem('selectedNeighborhood')
    return storedValue ? JSON.parse(storedValue) : null
  } catch (error) {
    return null
  }
}

/**
 * Custom base query that includes neighborhood ID and auth token
 * Use this for all API services that need neighborhood scoping
 */
export const createNeighborhoodAwareBaseQuery = (baseUrl) => {
  return fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}${baseUrl}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState()
      const token = state.authSlice.token
      const selectedNeighborhood = state.authSlice.selectedNeighborhood || getStoredNeighborhood()

      // Add auth token
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      // Add neighborhood ID
      if (selectedNeighborhood && selectedNeighborhood._id) {
        headers.set('X-Neighborhood-ID', selectedNeighborhood._id)
      }

      return headers
    }
  })
}

/**
 * Base query for admin/neighborhood endpoints (no neighborhood header needed)
 */
export const createAdminBaseQuery = (baseUrl) => {
  return fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}${baseUrl}`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice.token

      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    }
  })
}
